import { get, post } from '../api/axiosClient'
import {
    CountryDTOListApiResponse,
    StringApiResponse,
    StringPagedListPagedApiResponse,
} from '../../types/__generated__/addresses'
import { Locales } from '../../types/locales'
import { LocationApiResponse, LocationCheckRequest } from '../../types/__domain__/addresses'

const BASE_URL = '/api/addresses'

export const fetchCountries = async (locale: Locales): Promise<CountryDTOListApiResponse> => {
    const url = `${BASE_URL}/countries/${locale}`
    const response = await get(url)
    return response.data
}

export const fetchCities = async (
    searchQuery: string,
    countryCode: string
): Promise<StringPagedListPagedApiResponse> => {
    const params: string = new URLSearchParams({
        SearchTerm: searchQuery,
        Offset: '0',
        Limit: '25',
    }).toString()

    const url = `${BASE_URL}/selectlist/cities/${countryCode.toLowerCase()}?${params}`
    const response = await get(url)
    return response.data
}

export const matchAfasCity = async (countryCode: string, city: string): Promise<StringApiResponse> => {
    const url = `${BASE_URL}/match-city/${countryCode}/${city}`
    const response = await get(url)
    return response.data
}

export const checkLocation = async (request: LocationCheckRequest): Promise<LocationApiResponse> => {
    const response = await post(`${BASE_URL}/postalcode-check`, request)
    return response.data
}
